import React, { useContext , useEffect } from "react";
import styles from './Home.module.css';
import BrandCountrySelect from "../../brandCountrySelect/BrandCountrySelect";
import { useNavigate } from "react-router-dom";
import { BrandCountryContext } from "../../providers/BrandCountryProvider";
import HomeButton from "./HomeButtons";

export default function Home(){

    const {brand,setBrand,country,setCountry,language,setLanguage,disable,setDisable,handlePageChange} = useContext(BrandCountryContext);

    const navigate = useNavigate();

    const handleNavClick = (path) => {
        if(path === '!!!schemeRequest'){
            if(brand === "Premio"){
                window.open('https://form.jotform.com/252604125036043','_blank');
            } else if (brand === "Vulco"){
                window.open('https://form.jotform.com/252604125036043','_blank');
            }
        } else {
            window.scrollTo(0,0);
            navigate('/'+path);
        }
    }

    useEffect(() => {
        setDisable(false);
        handlePageChange(window.location.pathname);
    },[]);

    const guidelinesContent = [
        'Guidelines'
    ];
    const schemeRequestContent = [
        'External Scheme',
        'Internal Scheme',
        'Artwork pack'
    ];
    const logosContent = {
        'Premio': [
            'Premio Logos',
            'Signage Assets',
            'Premio Tuning'
        ],
        'Vulco': [
            'Vulco Logos',
            'Signage Assets'
        ],
        'Super Service': [
            'Super Service Logos',
            'Signage Assets'
        ]
    };
    const marketingContent = {
        'Premio': [
            'Marketing Images',
            'Container Adverts',
            'Digital Adverts',
            'Digital Signage Adverts',
            'Print Adverts',
            'Web Adverts'
        ],
        'Vulco': [
            'Marketing Images',
            'Container Adverts',
            'Digital Adverts',
            'Digital Signage Adverts',
            'Print Adverts',
            'Web Adverts'
        ],
        'Super Service': [
            'Container Artworks',
            'Marketing Images'
        ]
    };
    const generalContent = {
        'Premio': [
            'Site Animations',
            'Store Furniture Items',
            'Picture Frame Prints',
            'Icons & Favicons',
            'Connected Retail Solutions'
        ],
        'Vulco': [
            'Site Animations',
            'Store Furniture Items',
            'Picture Frame Prints',
            'Icons & Favicons',
            'Connected Retail Solutions',
            'Vulco Pro'
        ],
        'Super Service': [
            'Picture Frame Prints',
            'Icons'
        ]
    };

    return(
        <div className={styles.container}>
            <div className={styles.buttonContainer}>
                {brand !== 'Super Service'? <HomeButton gridColumn="1/4" gridRow="1/2" handleNavClick={handleNavClick} content={schemeRequestContent} pagePath={'schemeRequest'} name={'Scheme Request'} tagLine={'Site Submission Form'} /> : ''}
                <HomeButton gridColumn={brand !== 'Super Service'? "4/7" : "1/4"} gridRow="1/2" handleNavClick={handleNavClick} content={guidelinesContent} pagePath={'guidelines'} name={'Guidelines'} tagLine={'Brand Specific'} />
                <HomeButton gridColumn={brand !== 'Super Service'? "1/3" : "4/7"} gridRow={brand !== 'Super Service'? "2/3" : "1/2"} handleNavClick={handleNavClick} content={logosContent[brand]} pagePath={'logosSignage'} name={'Logos & Signage Assets'} tagLine={'Country & Language Specific'} />
                <HomeButton gridColumn={brand !== 'Super Service'? "3/5" : "1/4"} gridRow="2/3" handleNavClick={handleNavClick} content={marketingContent[brand]} pagePath={'marketingAssets'} name={'Marketing Assets'} tagLine={'Country & Language Specific'} />
                <HomeButton gridColumn={brand !== 'Super Service'? "5/7" : "4/7"} gridRow="2/3" handleNavClick={handleNavClick} content={generalContent[brand]} pagePath={'generalAssets'} name={'General Assets'} tagLine={'Brand Specific'} />
            </div>
        </div>
    )
}